import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { DateInput } from 'components/shared/Input';
import PostView from 'components/shared/PostView';
import ViewAll from 'components/shared/ViewAll';
import usePlaylistPosts from 'sdk/hooks/feed/usePlaylistPosts';
import { useParams } from 'react-router-dom';
import styles from './Playlist.module.scss';
import ContentSection from '../ContentSection';
import PlaylistSkeleton from './PlaylistSkeleton';
import NoContent from '../NoContent/NoContent';

function PlaylistMain({
  id,
  activeCategoryId,
  isDaily = false,
  count = 4,
  grid = false,
  title,
  asset,
  noHeader = false,
}: {
  id?: number,
  activeCategoryId?: number | string | null | undefined,
  isDaily?: boolean,
  count?: number,
  grid?: boolean,
  title?: string,
  asset?: number,
  noHeader?: boolean,
}) {
  const [fetching, setFetching] = useState(false);
  const [activePostId, setActivePostId] = useState('')

  const { id: categoryId } = useParams()
  let globalId = 'global'

  if (categoryId) {
    globalId = `cat-${categoryId}`
  }

  const {
    loaded, posts, feedData, playlistData, day, setDay,
  } = usePlaylistPosts(id, asset, activeCategoryId, isDaily, 4, globalId);

  let feedIdUrl = `asset-${asset}`

  if (id) {
    feedIdUrl = `playlist-${playlistData?.data?.id}`
  }
  if (id && asset) {
    feedIdUrl = `asset-${asset}_playlist-${playlistData?.data?.id}`
  }
  if (playlistData.data?.name === 'New') {
    feedIdUrl = globalId
  }

  useEffect(() => {
    setFetching(feedData.isFetching)
  }, [feedData.isFetching])
  const headerRight = (
    <>
      {isDaily ? (
        <DateInput
          className={styles.dayInput}
          value={day}
          onChange={(value: Date | null) => {
            setDay(value)
          }}
          dateFormat="MMM, dd"
          withArrow
          noIcon
        />
      ) : null}
      {
        posts?.length ? <ViewAll url={id ? `/playlist/${playlistData?.data?.name}` : `/playlist/${playlistData?.data?.name}?asset=${asset}`} /> : null
      }
    </>
  )

  if (!posts.length && !isDaily && loaded) {
    return null
  }

  if (fetching || !loaded) {
    return (
      <PlaylistSkeleton
        grid={grid}
        count={count}
        title={title || playlistData?.data?.name}
        headerRight={headerRight}
        noHeader={noHeader}
      />
    )
  }

  return (
    <ContentSection
      title={title || playlistData?.data?.name}
      headerRight={headerRight}
      noHeader={noHeader}
    >
      <div className={clsx(
        styles.playlistPosts,
        grid && styles.playlistPostsGrid,
        count === 3 && styles.playlistPosts_3,
        feedData.isLoading && styles.playlistPosts_loading,
      )}
      >
        {posts.map((post: any, idx: number) => (
          <div
            className={clsx(
              styles.playlistItem,
              grid && styles.playlistItemGrid,
              (grid && idx === 0) && styles.playlistItemGridLarge,
            )}
            key={post?.id}
            onMouseEnter={() => setActivePostId(post?.id)}
            onMouseLeave={() => setActivePostId('')}
          >
            <PostView
              feedId={feedIdUrl}
              activeIndex={idx}
              feedName="global_flat"
              data={post}
              isDaily={isDaily}
              size={count}
              gridItemSize={(idx === 0) ? 'large' : 'small'}
              grid={(posts?.length > 3) && grid}
              isActive={post?.id === activePostId}
              firstAssetId={asset}
            />
          </div>
        ))}
      </div>
      {!posts.length && (
        <NoContent
          className={styles.noContent}
          message="No data satisfying the filters"
          small
        />
      )}
    </ContentSection>
  )
}

function Playlist({
  id,
  activeCategoryId,
  isDaily = false,
  count = 4,
  grid = false,
  loading = false,
  title = '',
  asset,
  noHeader = false,
}: {
  id?: number,
  activeCategoryId?: number | string | null | undefined,
  isDaily?: boolean,
  count?: number,
  grid?: boolean,
  loading?: boolean,
  title?: string
  asset?: number,
  noHeader?: boolean,
}) {
  if (loading) {
    return (
      <PlaylistSkeleton grid={grid} count={count} />
    )
  }

  return (
    <PlaylistMain
      id={id}
      activeCategoryId={activeCategoryId}
      isDaily={isDaily}
      count={count}
      grid={grid}
      title={title}
      asset={asset}
      noHeader={noHeader}
    />
  )
}

export default Playlist
